import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { InvoicesDetails } from "../../models/invoice-history.interface";
import { Observable } from "rxjs";
import { tap, map } from "rxjs/operators";
import { SessionService } from "../session.service";
import { ApiEndpoints } from "src/config/api-endpoints";

@Injectable({
    providedIn: 'root'
  })
  export class InvoicesDetailService {
   // private apiUrl = 'https://ib-wallet-dev-api.azurewebsites.net/api/DigitalWalletAPI/dwgetinvoicedetails';

   private apiUrl = ApiEndpoints.invoicedetails;
   isPPI:boolean=false;
  
    constructor(private http: HttpClient,public sessionServiceAPI: SessionService) {
      this.isPPI = this.sessionServiceAPI.isPPI()?? false;
    }
  
  // In transaction-history.service.ts
  fetchInvoiceDetails(walletID: string, walletRole: string, sourceSystem: string = 'gw',policyNumber:string,payorID:number=0): Observable<any> {
    // Construct the request body according to the API's expected format
    let sessionID=sessionStorage.getItem("SessionID");
    sourceSystem=this.isPPI?"PPI":sourceSystem;
    const requestBody = { walletID, walletRole, sourceSystem ,sessionID,payorID,policyNumber};
    let wallettoken=sessionStorage.getItem("walletheaders");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        'Content-Type': 'application/json',
        "Authorization": "bearer " + wallettoken
      }),
    };
    // return this.http.post<InvoicesDetails>(this.apiUrl, requestBody,httpOptions);
     // Use the map operator to handle the new API response structure
        return this.http.post<any>(this.apiUrl, requestBody, httpOptions).pipe(
            map(response => {
              //Check for 'onl' or 'ppi' and return the result object
              if (response?.onl) {
                  // Ensure a fallback is in place for `result`
                  return {
                    ...response,
                    result: response.onl 
                  };
              } else if (response?.ppi) {
                  return {
                    ...response,
                    result: response.ppi 
                  };
              }
              // For any other case, return the original response
              return response;
            })
        );
  }
} 